import { HolidayRequestStatus, HolidayTime } from "../enums/Index";
import { Model } from "./Model";
import { User } from "./User";

export interface HolidayRequest extends Model {
	endDate: Date;
	endTime: HolidayTime;
	holidayLength: number;
	requestStatus: HolidayRequestStatus;
	requestedBy: User;
	requestedById: number;
	reviewdById?: number;
	startDate: Date;
	startTime: HolidayTime;
	year: number;
}

export class HolidayRequest implements HolidayRequest {
	endDate = new Date;
	startDate = new Date;

	constructor(data?: Partial<HolidayRequest>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}